export function getExternalLinkAttributes() {
  return {
    rel: 'nooperner nofollow',
    target: '_blank',
  };
}
